import { useState, useRef, useEffect, useSyncExternalStore } from 'react';
import {
  subscribeChartExportDesktopLayout,
  getChartExportDesktopLayout,
  getChartExportDesktopLayoutServerSnapshot,
} from '../utils/chartExportLayout';

export const useChartState = () => {
  const exportDesktopLayout = useSyncExternalStore(
    subscribeChartExportDesktopLayout,
    getChartExportDesktopLayout,
    getChartExportDesktopLayoutServerSnapshot
  );
  const [compareMenuOpen, setCompareMenuOpen] = useState(false);
  const [compareButtonRef, setCompareButtonRef] = useState(null);
  const [compareButtonRect, setCompareButtonRect] = useState({ top: 0, right: 0 });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const chartIsMobile = isMobile && !exportDesktopLayout;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isTouching, setIsTouching] = useState(false);
  
  const menuRef = useRef(null);
  const compareMenuRef = useRef(null);

  const getDropdownLeftPosition = (selectedChart = '', isHistoricalScores = false) => {
    if (!chartIsMobile) {
      return '-12px';
    }

    if (selectedChart.toLowerCase().includes('vs')) {
      return '-12px';
    }
    
    if (compareMenuOpen) {
      const gap = 2;
      
      if (isHistoricalScores && selectedChart.toLowerCase().includes('percentile')) {
        const compareMenuWidth = 98;
        return `${-12 - compareMenuWidth - gap}px`;
      }

      const compareMenuWidth = 88;
      return `${-12 - compareMenuWidth - gap}px`;
    }
    
    return '-12px';
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (compareButtonRef) {
      const rect = compareButtonRef.getBoundingClientRect();
      setCompareButtonRect({ top: rect.top, right: rect.right });
    }
  }, [compareButtonRef]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
      
      if (compareMenuOpen && !event.target.closest('.compare-button')) {
        setCompareMenuOpen(false);
        setCompareButtonRef(null);
      }
      
      if (compareMenuRef.current && !compareMenuRef.current.contains(event.target)) {
        setCompareMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [compareMenuOpen]);

  return {
    compareMenuOpen,
    setCompareMenuOpen,
    compareButtonRef,
    setCompareButtonRef,
    compareButtonRect,
    isMobile: chartIsMobile,
    windowWidth,
    isMenuOpen,
    setIsMenuOpen,
    isTouching,
    setIsTouching,
    menuRef,
    compareMenuRef,
    getDropdownLeftPosition
  };
};